import { Box, Typography } from '@mui/material';
import { ReactElement } from 'react';
import { FormattedMessage } from 'intl';
import { InspectionTranslationKeys } from 'intl/keys';
import { shouldShowAnsweredSummary } from 'shared/domain/inspection/notApplicableUi';

interface ChecklistSectionSummaryMetaProps {
  answeredItems: number;
  totalItems: number;
  isNotApplicable?: boolean;
}

export function ChecklistSectionSummaryMeta({
  answeredItems,
  totalItems,
  isNotApplicable = false,
}: ChecklistSectionSummaryMetaProps): ReactElement | null {
  if (!shouldShowAnsweredSummary(isNotApplicable, totalItems)) {
    return null;
  }

  return (
    <Box
      data-qa='section-summary-answered'
      sx={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
      }}
    >
      <Typography variant='body2' color='text.secondary'>
        <FormattedMessage
          id={InspectionTranslationKeys.sectionAnsweredSummary}
          values={{ answered: answeredItems, total: totalItems }}
        />
      </Typography>
    </Box>
  );
}
